<template>
  <Dropdown
    :style="{ width: '100%', maxWidth: '200px'}"
    :loading="loading"
    :disabled="disable"
    :options="envio.servicios"
    v-model="form.servicioId"
    placeholder="Seleccionar servicio"
    optionValue="id"
    :optionLabel="(s) => `${s.precio} - ${s.proveedor} - ${s.servicio} - ${s.tipo_entrega} ${s.sucursal_entrega === undefined ? '' :  s.sucursal_entrega} ${s.sucursal_entrega_id === undefined ? '' : s.sucursal_entrega_id }`"
    @change="$emit('cambio', {servicioId: form.servicioId, envioId: this.envio.id})"
  />
</template>

<script>
export default {
  name: "ServiciosSelect",
  props: {
    envio: Object,
  },
  data() {
    return {
        form:{
            servicioId: null,
            envioId: null,
        },
    };
  },
  methods: {
  },
};
</script>